// Capability queries cannot distinguish touch from mouse on a hybrid device.
// Only decorative public :hover rules consult this attribute; keyboard focus
// and functional states do not. Passive listeners leave gestures untouched.
export const installTouchInteractions = () => {
  const root = document.documentElement
  const touch = event => {
    if (event.pointerType === "touch")
      root.setAttribute("data-trinity-touch", "")
    else mouse(event)
  }
  const mouse = event => {
    if (
      event.pointerType === "mouse" &&
      root.hasAttribute("data-trinity-touch")
    ) {
      root.removeAttribute("data-trinity-touch")
    }
  }
  const options = { capture: true, passive: true }
  document.addEventListener("pointerdown", touch, options)
  document.addEventListener("pointerover", touch, options)
  document.addEventListener("pointermove", mouse, options)
  return () => {
    document.removeEventListener("pointerdown", touch, options)
    document.removeEventListener("pointerover", touch, options)
    document.removeEventListener("pointermove", mouse, options)
    root.removeAttribute("data-trinity-touch")
  }
}
